{
  "de": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "Spam-Beschwerden können hier nicht reaktiviert werden. Dies ist nur manuell über {link} möglich.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Suche",
      "selected": "Ausgewählt"
    }
  }
}
